import { Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ReferenceDataLabels } from '../../lib/constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../lib/constants/reference-data-option-lists';
import { CaseSetupDto } from '../../lib/models/dto/case-setup-dto.model';
import { AnsweredQuestionViewModel } from '../models/answered-question-viewmodel.model';

@Directive()
export abstract class BaseEligibilityQuestionsComponent implements OnInit {
  public readonly referenceDataOptionLists = ReferenceDataOptionLists;
  public readonly referenceDataLabels = ReferenceDataLabels;

  @Input() public caseSetup: CaseSetupDto;
  @Input() public questions: Array<AnsweredQuestionViewModel>;

  @Output() public readonly isValidChange = new EventEmitter<boolean>();

  public ngOnInit(): void {
    this.isValidChange.emit(this.checkValidity());
  }

  public changePropertyLocation(location: string): void {
    this.caseSetup.PropertyLocation = location;
    this.isValidChange.emit(this.checkValidity());
  }

  public changeQuestionAnswer(question: AnsweredQuestionViewModel, answer: string): void {
    question.ProvidedAnswer = answer;
    this.isValidChange.emit(this.checkValidity());
  }

  public abstract checkValidity(): boolean;
}
